import { z } from "zod";

export const activitySchema = () => {
  return z.object({
    name: z.string().min(1),
    image: z.any().optional(),
    categories: z.array(z.number()).min(1),
    active: z.boolean(),
  });
};

export type ActivityFormValues = z.infer<ReturnType<typeof activitySchema>>;
